module.exports = __webpack_public_path__ + "img/qr-pdf.b9983cce.svg";